import { Box } from "@mui/material";
import { dashIfEmpty } from "../../../constants/utils";
import type {
  CareOfDelivery,
  Consignee,
} from "../../../services/prePlanningService.types";
import { CareOfDeliveryTooltip } from "./CareOfDeliveryTooltip";

type CareOfDeliveryCellProps = {
  consignee?: Consignee | null;
  careOfDelivery?: CareOfDelivery | null;
  serviceLevel?: string | null;
  isMexicoTooltipEnabled?: boolean;
};

export const CareOfDeliveryCell = ({
  consignee,
  careOfDelivery,
  serviceLevel,
  isMexicoTooltipEnabled,
}: CareOfDeliveryCellProps) => {
  if (!isMexicoTooltipEnabled || serviceLevel !== "MXUS-LTL") {
    return <>{dashIfEmpty(consignee?.name)}</>;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={0.5}
    >
      {dashIfEmpty(careOfDelivery?.name)}
      <CareOfDeliveryTooltip
        careOfDelivery={careOfDelivery}
        consignee={consignee}
      />
    </Box>
  );
};
